import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './store/actions'
import * as mutations from './store/mutations'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    editMode: false,
    players: [],
    gameStarted: false,
    kartengeber: 0,
    saveSettings: {
      saveName : "",
      autoSave: false
    }
  },
  mutations,
  actions,
  getters: {
    players(state) {
      return state.players
    },
    playerByName: (state) => (name) => {
      return state.players.filter(p => p.name == name)[0]
    },
    gameByName: (state)  => (name) => {
      return state.availableGames.find(g => g.gamename == name)
    },
    gameStarted(state) {
        return state.gameStarted
    },
    kartengeber(state) {
      return state.kartengeber
    },
    editMode(state) {
      return state.editMode
    },
    autoSaveSettings(state) {
      return state.saveSettings
    },
  }
})